import type { MissionsXpRiveConfig } from '../../services/types';

// Prefix shared by all Missions data-testids.
export const MISSIONS_TEST_ID_PREFIX = 'crown-missions';

// Fallback when the 'missions_xp_rive_config' LD flag is unset — empty URLs mean
// "use the bundled .riv asset", matching each file's authored state machine name.
export const DEFAULT_MISSIONS_XP_RIVE_CONFIG: MissionsXpRiveConfig = {
  missionsInfoEnUrl: '',
  missionsInfoDeUrl: '',
  xpGiftUrl: '',
  missionsInfoStateMachine: 'State Machine 1',
  xpGiftStateMachine: 'State Machine 1',
};
